import { Base64 } from 'js-base64';
import { analyticsLocalStorage } from '.';

interface Params {
  courseId: number;
}

// clear all entries for course
const clearAllEntries = ({ courseId }: Params) => {
  try {
    const keys = analyticsLocalStorage.getKeys();

    for (const key of keys) {
      let value = localStorage.getItem(key);

      const item = JSON.parse(Base64.decode(value));
      if (item.courseId === courseId) localStorage.removeItem(key);
    }
  } catch {
    // do nothing
  }
};

export default clearAllEntries;
